import { Button, Modal, Typography } from 'antd';
import React, { createContext, ReactNode, useMemo, useState } from 'react';
import './style.css';

type DialogConfig = {
  message: string;
  okText: string;
  cancelText: string;
  onOk?: () => void;
  onCancel?: () => void;
};

type DialogContextValue = {
  openDialog: (config: DialogConfig) => void;
};
export const DialogContext = createContext<DialogContextValue>({
  openDialog: () => {},
});

const DialogProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState<DialogConfig | null>(null);

  const contextValue = useMemo(() => {
    return {
      openDialog: (config: DialogConfig) => {
        setConfig(config);
        setOpen(true);
      },
    };
  }, []);

  const handleCancel = () => {
    setOpen(false);
    config?.onCancel?.();
  };

  const handleOk = () => {
    setOpen(false);
    config?.onOk?.();
  };

  return (
    <DialogContext.Provider value={contextValue}>
      {config ? (
        <Modal
          open={open}
          footer={null}
          style={{ top: '40vh' }}
          onCancel={handleCancel}
        >
          <div className="dialog-container">
            <Typography.Text style={{ marginBottom: 16 }}>
              {config.message}
            </Typography.Text>
            <div className="d-flex">
              <Button onClick={handleCancel} block style={{ marginRight: 4 }}>
                {config.cancelText}
              </Button>
              <Button danger onClick={handleOk} block style={{ marginLeft: 4 }}>
                {config.okText}
              </Button>
            </div>
          </div>
        </Modal>
      ) : null}
      {children}
    </DialogContext.Provider>
  );
};

export default DialogProvider;
